import { CartProduct } from "../store/slice/cartSlice";
import apiClient from "./apiClient";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const getShoppingCart = createAsyncThunk(
  "shoppingCart/getShoppingCart",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/cart`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const updateShoppingCart = createAsyncThunk(
  "shoppingCart/updateShoppingCart",
  async (params: CartProduct[], { rejectWithValue }) => {
    try {
      return params;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const addCartItem = createAsyncThunk(
  "shoppingCart/addCartItem",
  async (params: CartProduct, { rejectWithValue }) => {
    try {
      toast.success(
        params.quantity === 1
          ? "Le produit a été ajouté au panier"
          : "Les produits ont été ajoutés au panier",
        {
          className: "toast-success",
        }
      );
      return params;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const deleteCartItem = createAsyncThunk(
  "shoppingCart/deleteCartItem",
  async (params: { code: string; remove: boolean }, { rejectWithValue }) => {
    try {
      return params;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const updateCart = createAsyncThunk(
  "shoppingCart/updateCart",
  async (
    params: { cart: CartProduct[]; token: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiClient.post(
        `${API_URL}/cart/add`,
        params.cart,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${params.token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const updateCartItem = createAsyncThunk(
  "shoppingCart/updateCartItem",
  async (params: CartProduct, { rejectWithValue }) => {
    try {
      return params;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const getProductById = async (id: string) => {
  try {
    const response = await apiClient.get(`${API_URL}/products/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error: any) {
    return new Error(error.response?.data || "Erreur inconnue");
  }
};

export const setCartToSession = (
  currentCart: CartProduct[],
  newItem: CartProduct
) => {
  const existingItemIndex = currentCart.findIndex(
    (item) => item.productCode === newItem.productCode
  );
  let newCart = [];
  if (existingItemIndex !== -1) {
    const updatedCart = [...currentCart];
    updatedCart[existingItemIndex].quantity += newItem.quantity;
    newCart = [...updatedCart];
  } else {
    newCart = [...currentCart, newItem];
  }
  sessionStorage.setItem("shopping_cart", JSON.stringify(newCart));
};

export const getCartFromSession = (): CartProduct[] => {
  const cartString = sessionStorage.getItem("shopping_cart");
  try {
    return cartString ? JSON.parse(cartString) : [];
  } catch (e) {
    return [];
  }
};

export const clearCartSession = () => {
  sessionStorage.removeItem("shopping_cart");
};

export const countQuantityCart = (cart: CartProduct[]) =>
  cart.reduce((acc, item) => acc + item.quantity, 0);
